var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "account-deletion-modal",
      attrs: {
        id: "account-deletion-modal",
        "header-class": "account-deletion-header",
        centered: "",
        "ok-variant": "danger",
        "ok-title": _vm.$t("Delete"),
        "cancel-title": _vm.$t("Cancel")
      },
      on: { ok: _vm.handleSubmit },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("h3", [
                _vm._v(_vm._s(_vm.$t("profile.delete_account.modal.title")))
              ])
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("p", {
          staticClass: "mt-2",
          domProps: {
            innerHTML: _vm._s(_vm.$t("profile.delete_account.modal.content"))
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-080d92e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-080d92e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/AccountDeletionModal.vue
// module id = Zvyq
// module chunks = 0